import type { AssetType } from "@overmap-ai/common"
import { restructureSelectorWithArgs } from "@overmap-ai/core"
import { createSelector } from "@reduxjs/toolkit"

import { getWeekDateRange } from "../../utils/date"
import type { RootState } from "../typings"

export const selectHiddenAssetTypeIds = (state: RootState) => state.mapVisibility.hiddenAssetTypeIds

export const selectIsAssetTypeHidden = restructureSelectorWithArgs(
	createSelector(
		[selectHiddenAssetTypeIds, (_, assetTypeId: string) => assetTypeId],
		(visibleAssetTypeIds, assetTypeId) => {
			return assetTypeId in visibleAssetTypeIds
		},
	),
)

export const selectHiddenIssueTypeIds = (state: RootState) => state.mapVisibility.hiddenIssueTypeIds

export const selectIsIssueTypeHidden = restructureSelectorWithArgs(
	createSelector(
		[selectHiddenIssueTypeIds, (_, issueTypeId: string) => issueTypeId],
		(visibleIssueTypeIds, issueTypeId) => {
			return issueTypeId in visibleIssueTypeIds
		},
	),
)

export const selectHiddenProjectFileIds = (state: RootState) => state.mapVisibility.hiddenProjectFileIds

export const selectIsProjectFileVisible = restructureSelectorWithArgs(
	createSelector(
		[selectHiddenProjectFileIds, (_, projectFileId: string) => projectFileId],
		(visibleProjectFileIds, projectFileId) => {
			return !(projectFileId in visibleProjectFileIds)
		},
	),
)

const weekDateRange = getWeekDateRange()
export const selectGeoImageDateRange = (state: RootState) => state.mapVisibility.geoImageDateRange ?? weekDateRange

export const selectAssetMapColorMode = (state: RootState) => state.mapVisibility.assetMapColorMode

export const selectMapStyle = (state: RootState) => state.mapVisibility.mapStyle

export const selectShowProjectBounds = (state: RootState) => state.mapVisibility.showProjectBounds

export const selectShowAssetLabels = restructureSelectorWithArgs(
	createSelector(
		[
			(state: RootState) => state.mapVisibility.showAssetLabelsByAssetTypeId,
			(_, assetTypeId: AssetType["uuid"]) => assetTypeId,
		],
		(showAssetLabelsByAssetTypeId, assetTypeId) => showAssetLabelsByAssetTypeId?.[assetTypeId] ?? false,
	),
)

export const selectAssetGeometryFillOpacity = (state: RootState) => state.mapVisibility.assetGeometryFillOpacity

export const selectAssetGeometryStrokeOpacity = (state: RootState) => state.mapVisibility.assetGeometryStrokeOpacity
